<template>
  <div
    class="yhc-ef-item-list--add-new-kazai-area yhc-ef-item-list--item-content"
    @click.prevent="() => openAddNewKazaiModal()"
  >
    <div
      class="yhc-ef-item-list--add-new-kazai-area--btn d-flex justify-content-center align-items-center"
      :class="
        isKaguidoOption
          ? 'yhc-ef-item-list--add-new-kazai-area--btn-for-kaguido-option'
          : ''
      "
    >
      + 家財を選択する
    </div>
  </div>
  <b-modal
    title="該当する家財をクリックしてください"
    ref="selectKazaiModal"
    size="lg"
    dialog-class="yhc-ef-modal-dialog--kazaiCategory"
    ok-only
    ok-title="戻る"
    ok-variant="outline-secondary"
    class="yhc-modal"
    no-close-on-backdrop
    no-close-on-esc
  >
    <YhcEFItemListKazaiCategoryList
      @selectKazaiCategory="(kazaiCategoryId) => selectKazaiCategory(kazaiCategoryId)"
    />
  </b-modal>
  <b-modal
    :title="detailModalTitle"
    ref="kazaiDetailInputModal"
    size="md"
    dialog-class="yhc-ef-modal-dialog--kazaiForm"
    ok-only
    ok-title="戻る"
    ok-variant="outline-secondary"
    title-class="bg-light"
    class="yhc-modal"
    no-close-on-backdrop
    no-close-on-esc
  >
    <YhcEFKazaiDetailInput
      v-if="selectedSubCategory && !isKaguidoOption"
      :subCategoryId="selectedSubCategory"
      @addKazai="(kazaiData) => addKazai(kazaiData)"
    />
    <YhcEFKazaiKaguidoDetailInput
      v-if="selectedSubCategory && isKaguidoOption"
      :subCategoryId="selectedSubCategory"
      :isKaguidoFrom="isKaguidoFrom"
      @addKazai="(kazaiData) => addKazaiKaguidoOption(kazaiData)"
    />
  </b-modal>
</template>
<script lang="ts">
import YhcEFItemListKazaiCategoryList from './YhcEFItemListKazaiCategoryList.vue'
import YhcEFKazaiDetailInput from '../YhcEFKazaiDetailInput/YhcEFKazaiDetailInput.vue'
import { YhcEFInputOneKazaiTypeDataObject } from '../../YhcEFInputOneKazaiTypeDataObject'
import { YhcEstimateFormFrontService } from '../../YhcEstimateFormFrontService'
import { $yhcGA4EventSender } from '../../YhcGA4EventSender'
import YhcEFKazaiKaguidoDetailInput from '../YhcEFKazaiKaguidoDetailInput/YhcEFKazaiKaguidoDetailInput.vue'
import { YhcEFInputOneKazaiTypeDataObjectForKaguidoOption } from '../../YhcEFInputOneKazaiTypeDataObjectForKaguidoOption'

export default {
  name: 'YhcEFItemListAddNewKazaiArea',
  components: {
    YhcEFKazaiDetailInput,
    YhcEFItemListKazaiCategoryList,
    YhcEFKazaiKaguidoDetailInput,
  },
  inject: ['YhcEstimateFormFrontServiceInstance'],
  props: {
    // 家具移動オプションかどうか
    isKaguidoOption: {
      type: Boolean,
      default: false,
    },
    // 家具移動オプションのうち、お預かり先かどうか
    isKaguidoFrom: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    yhcEf(): YhcEstimateFormFrontService {
      return this.YhcEstimateFormFrontServiceInstance
    },
    detailModalTitle() {
      return !this.isKaguidoOption
        ? '運びたいお荷物の種類やサイズ、オプションを選択してください'
        : '移動したいお荷物の種類や移動先、オプションを選択してください'
    },
    isContainUnavailableArea(): boolean {
      return !!this.yhcEf.$userInputData.isContainUnavailableArea
    },
  },
  watch: {
    isContainUnavailableArea(unavailable: boolean) {
      if (unavailable) {
        this.hideKazaiModals()
      }
    },
  },
  mounted() {
    // 開発用 only, 開発環境でのみ自動で開く
    if (process.env.NODE_ENV === '__development') {
      this.openAddNewKazaiModal()
    }
  },
  data() {
    return {
      selectedSubCategory: null,
    }
  },
  methods: {
    hideKazaiModals() {
      this.$refs.selectKazaiModal?.hide?.()
      this.$refs.kazaiDetailInputModal?.hide?.()
    },
    openAddNewKazaiModal() {
      this.selectedSubCategory = null
      this.$refs.selectKazaiModal.show()
    },
    selectKazaiCategory(kazaiCategoryId) {
      this.selectedSubCategory = kazaiCategoryId
      this.$refs.kazaiDetailInputModal.show()
    },
    async addKazai(kazaiData: YhcEFInputOneKazaiTypeDataObject) {
      this.$refs.selectKazaiModal.hide()
      this.$refs.kazaiDetailInputModal.hide()
      this.yhcEf.$userInputData.addKazaiData(kazaiData)
      this.yhcEf.$userInputData.loadDeliveryPeakSeasonRules() // 繁忙期シーズンルールを更新
      await this.yhcEf.$userInputData.recalculateDeliveryDates()
      $yhcGA4EventSender.addKazai(kazaiData)
    },
    addKazaiKaguidoOption(kazaiData: YhcEFInputOneKazaiTypeDataObjectForKaguidoOption) {
      this.$refs.selectKazaiModal.hide()
      this.$refs.kazaiDetailInputModal.hide()
      // お預かり先かお届け先かで分岐
      if (this.isKaguidoFrom) {
        this.yhcEf.$userInputData.addKazaiDataForKaguidoOptionCollectionDestination(
          kazaiData,
        )
        $yhcGA4EventSender.addKazaiForKaguidoOption(kazaiData, true)
      } else {
        this.yhcEf.$userInputData.addKazaiDataForKaguidoOptionDeliveryDestination(
          kazaiData,
        )
        $yhcGA4EventSender.addKazaiForKaguidoOption(kazaiData, false)
      }
    },
  },
}
</script>
